import { connect } from 'react-redux'
import MainMenu from './MainMenu'

const mapStateToProps = ({
  mainMenu,
  onlyCash,
  catalog,
  oidc: {
    user: { profile }
  }
}) => ({
  tradeMenu: (profile
    ? mainMenu[profile['custom:catalog_id']]
      ? mainMenu[profile['custom:catalog_id']]
      : mainMenu['default']
    : mainMenu['default']
  ).tradeMenu,
  categoryMenu: (profile
    ? mainMenu[profile['custom:catalog_id']]
      ? mainMenu[profile['custom:catalog_id']]
      : mainMenu['default']
    : mainMenu['default']
  ).categoryMenu,
  onlyCash,
  catalogJustCash: catalog.onlyCash,
  profile: profile
})

export default connect(mapStateToProps)(MainMenu)



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenuContainer.js